import api from "./Api";

class VendedorTelefoneService {
  GetVendedorTelefone(payload) {
    return api.get("/v1/vendedorTelefone/" + payload).then((response) => {
      return response.data;
    });
  }

  PostVendedorTelefone(payload) {
    return api.post("/v1/vendedorTelefone/", payload).then((response) => {
      return response.data;
    });
  }

  PutVendedorTelefone(payload) {
    return api.put("/v1/vendedorTelefone/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteVendedorTelefone(payload) {
    return api.delete("/v1/vendedorTelefone/" + payload).then((response) => {
      return response.data;
    });
  }

  GetVendedorTelefoneOData(payload) {
    return api.get("/OData/VendedorTelefone" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new VendedorTelefoneService();
